export enum ClientTypeEnum {
  Client = 'client',
  Prospect = 'prospect',
}
